// src/components/ranking/TeamRankingTable.jsx
// Like RankingTable, one row per fixed team instead of per player (see the 'fixed-teams' format): both of a
// team's players always play together, so they always have the same result, shown as one row named after both.
import React from 'react';
import { CLASSIC_RANKING } from '../../utils/ranking';
import { COLUMNS, cell } from './RankingTable';

const teamName = (row) => row.players.map((player) => `${player.firstName} ${player.lastName}`).join(' & ');

// rankKey: which field is shown as the place ('groupRank' for the table of one group)
function TeamRankingTable({ standings, ranking = CLASSIC_RANKING, highlightId = null, rankKey = 'rank' }) {
    return (
        <div className="table-scroll">
            <table className="ranking-table">
                <thead>
                    <tr>
                        <th scope="col" className="rank-col">
                            #
                        </th>
                        <th scope="col" className="name-col">
                            Team
                        </th>
                        {COLUMNS.map((column) => (
                            <th key={column.key} scope="col" title={column.hint} className={column.key === 'score' ? 'score-col' : ''}>
                                {column.key === 'score' ? ranking.unit : column.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {standings.map((row) => (
                        <tr key={row.teamId} className={`${row.active ? '' : 'inactive'}${row.teamId === highlightId ? ' me' : ''}`.trim()}>
                            <td className="rank-col">{row[rankKey]}</td>
                            <th scope="row" className="name-col">
                                <span className="ranking-name">{teamName(row)}</span>
                                {!row.active && <span className="badge">Inactive</span>}
                            </th>
                            {COLUMNS.map((column) => (
                                <td key={column.key} className={column.key === 'score' ? 'score-col' : ''}>
                                    {cell(row, column.key, ranking)}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TeamRankingTable;
